import { useLocalAudioOutput } from '@providers/LocalAudioOutputProvider';
import { useMemo, type FC } from 'react';
import { Container, IconWrapper } from './style';
import SpeakerIcon from '/icon/speaker.svg';

const SpeakerToggle: FC = () => {
  const { isAudioOn, toggleAudio } = useLocalAudioOutput();

  const isActive = useMemo(() => isAudioOn, [isAudioOn]);

  return (
    <Container onClick={toggleAudio} isActive={isActive}>
      <IconWrapper>
        <img src={SpeakerIcon} />
      </IconWrapper>
      <span>스피커</span>
    </Container>
  );
};

export default SpeakerToggle;
